import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import Button from "../ui/Button";
import { Modal } from "../ui/Modal";
import useFetch from "../../hooks/useFetch";
import { IEntityChangeLogDetail } from "../../interfaces/endpoints/IEntityChangeLog.types";
import { getEntityChangeLog } from "../../services/EntityChangeLog.service";
import ChangeDetailsBody from "./ChangeDetailsBody";
import { ACTION_LABELS, labelForEntity } from "./changeHistoryLabels";

interface IChangeDetailsModal {
  logId: number;
  onClose: () => void;
  onReverted: () => void;
  // Set when this record was opened from an action's list of records, to go back to it.
  onBack?: () => void;
}

// Loads one history row and shows it in a modal; the revert lives inside the body.
const ChangeDetailsModal: FC<IChangeDetailsModal> = ({ logId, onClose, onReverted, onBack }) => {
  const { response, loading, error } = useFetch<IEntityChangeLogDetail, number>(getEntityChangeLog, {
    initRequest: true,
    params: logId
  });
  const row = response?.data;
  const name = row ? row.entityDisplay ?? `#${row.entityId}` : "";
  const title = row
    ? `${labelForEntity(row.entityName)} ${name}: ${ACTION_LABELS[row.action]}`
    : "Detajet e ndryshimit";

  let content = <p className="text-gray-500">Duke ngarkuar...</p>;
  if (!loading && error) content = <p className="text-red-600">Detajet nuk u ngarkuan.</p>;
  if (!loading && row) content = <ChangeDetailsBody row={row} onReverted={onReverted} />;

  return (
    <Modal
      show
      position="center"
      title={title}
      onClose={onClose}
      modalWidth="min(64rem, 95vw)"
      fitContent
    >
      <div className="p-5 text-sm">
        {onBack && (
          <Button
            btnType="custom"
            padding="px-0 py-0"
            fontWeight="font-medium"
            className="text-primary flex items-center gap-1 mb-4"
            onClick={onBack}
          >
            <ChevronLeftIcon className="w-4 h-4" />
            Kthehu te të gjitha ndryshimet
          </Button>
        )}
        {content}
      </div>
    </Modal>
  );
};

export default ChangeDetailsModal;
